import { NotificationConfig, NotificationType } from '@routific/hive';

export const rateLimitNotification = (): NotificationConfig => ({
  type: NotificationType.ERROR,
  id: 'rate-limit',
  message: 'Too many requests. Please wait a moment and try again.',
});
